import { render } from "./IconContainer.vue?vue&type=template&id=78fc984e"
import script from "./IconContainer.vue?vue&type=script&lang=js"
export * from "./IconContainer.vue?vue&type=script&lang=js"

import "./IconContainer.vue?vue&type=style&index=0&id=78fc984e&lang=scss"

import exportComponent from "C:\\Server-Testumgebung\\way-academy-app-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__